const SET_CONFIG = 'intl/SET_CONFIG';
const setConfig = (payload)=>({
        type: SET_CONFIG,
        payload
    })
;

export { SET_CONFIG, setConfig };
//# sourceMappingURL=actions.js.map
